<div
  #statusContainer
  class="status-container"
  [appTooltip]="usersListTooltip"
  [appTooltipCloseDelay]="0"
  [appTooltipStayWhenTooltipHover]="true"
  [appTooltipStayWhenTooltipHoverDelay]="0"
  [appTooltipPlacement]="'bottom-center'"
>
  <app-pencil-icon
    *ngIf="iconName"
    class="icon-container"
    [name]="iconName"
    [type]="IconTypes.svgIcon"
  >
  </app-pencil-icon>

  <div class="users-list-container">
    <app-lightweight-user-avatar
      *ngFor="let user of users | slice: 0:numberOfUsersToShow(users)"
      class="users-list-item"
      [isUser]="!!user"
      [profileImage]="user?.profile_image"
      [userName]="user?.name"
      [enableImageBorder]="true"
      [width]="24"
    >
    </app-lightweight-user-avatar>

    <div *ngIf="users.length > maxLength" class="users-list-item user-counts text">
      {{ users.length - maxLength + 1 }}
    </div>
  </div>
</div>

<ng-template #usersListTooltip>
  <app-tooltip arrow="top" class="users-list-tooltip" [showTemplate]="true">
    <div (mouseleave)="waitingRoomTooltipComponent.reset()">
      <app-space-users-tooltip-content
        #waitingRoomTooltipComponent
        classes="menu-inner-content"
        [users]="users"
      ></app-space-users-tooltip-content>
    </div>
  </app-tooltip>
</ng-template>
